/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(() => {
  const initializeTabs = () => {
    if (typeof VanillaTabs === 'undefined') return;
    if (!document.querySelector('.product-desc-tabs:not(.tabs__initialized) li')) return;
    new VanillaTabs({ selector: '.product-desc-tabs:not(.tabs__initialized)', type: 'horizontal', responsiveBreak: 640, activeIndex: 0 });
  };
  const initialize = () => {
    initializeTabs();
    const main = document.getElementById('main');
    if (!main) return;
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.product-desc-tabs') || node.querySelector('.product-desc-tabs'))))) initializeTabs();
    }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initializeTabs);
  document.addEventListener('cart:rerendered', () => {
    if (typeof window.calculateNewCartPrice === 'function' && typeof window.updateAffirmPromos === 'function') window.updateAffirmPromos(window.calculateNewCartPrice());
  });
})();

/* Quote app buttons must not live inside Warehouse's buy-button element:
   that element treats child clicks as an add-to-cart action. */
(() => {
  const separateQuoteButtons = () => {
    document.querySelectorAll('buy-button .storeify-button-detail').forEach(group => {
      const buyButton = group.closest('buy-button');
      if (buyButton) buyButton.insertAdjacentElement('afterend', group);
    });
  };
  const start = () => {
    separateQuoteButtons();
    new MutationObserver(separateQuoteButtons).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
